import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from 'components/v2/Button';

export const SectionBox = styled(Box)(({ theme }) => ({
  padding: 0,
  gap: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: 500,
  textTransform: 'capitalize',
}));

export const ChipWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
}));

export const SubsectionLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  marginBottom: theme.spacing(1),
  textTransform: 'capitalize',
}));

export const DropdownLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '14px',
  marginBottom: theme.spacing(0.25),
}));

export const StyledRadioLabel = styled(FormControlLabel)(({ theme }) => ({
  '& .MuiFormControlLabel-label': {
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
}));

export const FooterButton = styled(Button)({
  textTransform: 'uppercase',
  fontWeight: 500,
  fontSize: '14px',
  minWidth: 130,
  height: 48,
});

export const ClearButton = styled(FooterButton)(({ theme }) => ({
  borderColor: theme.palette.divider,
  color: theme.palette.text.primary,
}));

export const CancelButton = styled(FooterButton)(({ theme }) => ({
  backgroundColor: theme.palette.darkSand.white80,
  color: theme.palette.darkSand.black80,
  '&:hover': {
    backgroundColor: theme.palette.darkSand.white60,
  },
}));

export const ClientDetailsRow = styled(Stack)({
  flexDirection: 'column',
});

export const FooterRow = styled(Stack)(({ theme }) => ({
  width: '100%',
  flexWrap: 'wrap',
  gap: theme.spacing(1.5),
  [theme.breakpoints.up('sm')]: {
    flexWrap: 'nowrap',
    gap: 0,
  },
}));
